import { Controller } from "@hotwired/stimulus"
import { EditorView, basicSetup } from "codemirror"
import { html } from "@codemirror/lang-html"
import { xml } from "@codemirror/lang-xml"
import { oneDark } from "@codemirror/theme-one-dark"

export default class extends Controller {
  static targets = ["textarea", "editor"]
  static values = { language: { type: String, default: "html" }, height: { type: String, default: "500px" } }

  declare textareaTarget: HTMLTextAreaElement
  declare editorTarget: HTMLElement
  declare languageValue: string
  declare heightValue: string

  private view: EditorView | null = null

  connect() {
    this.view = new EditorView({
      doc: this.textareaTarget.value,
      extensions: [
        basicSetup,
        this.languageExtension(),
        oneDark,
        EditorView.lineWrapping,
        EditorView.theme({
          "&": { height: this.heightValue },
          ".cm-scroller": { overflow: "auto" },
        }),
      ],
      parent: this.editorTarget,
    })

    this.textareaTarget.form?.addEventListener("submit", this.syncToTextarea)
    document.addEventListener("shown.bs.tab", this.handleTabShown)
  }

  disconnect() {
    this.textareaTarget.form?.removeEventListener("submit", this.syncToTextarea)
    document.removeEventListener("shown.bs.tab", this.handleTabShown)
    this.view?.destroy()
    this.view = null
  }

  private languageExtension() {
    return this.languageValue === "xml" ? xml() : html()
  }

  private handleTabShown = (event: Event) => {
    const button = event.target as HTMLElement
    const paneSelector = button.getAttribute("data-bs-target")
    if (!paneSelector) return
    const pane = document.querySelector(paneSelector)
    if (pane?.contains(this.element)) {
      this.view?.requestMeasure()
    }
  }

  private syncToTextarea = () => {
    if (this.view) {
      this.textareaTarget.value = this.view.state.doc.toString()
    }
  }
}